// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseurl: 'https://cnh59c0f20.execute-api.us-east-1.amazonaws.com/dev/',
  baseTokenurl: 'https://localhost:44301/api/Auth/',
  APIKey: "ItxQH3djM04SjJ7fa0S9Oa0q8gCRYa1L7w1nXgG8",
  AADUserDetailsUrl: "https://graph.microsoft.com/v1.0/me/?$select=displayName,userPrincipalName,jobTitle,department,onPremisesSamAccountName",
  AADUserImageUrl: "https://graph.microsoft.com/v1.0/me/photo/$value",
  AADconfig: {
    tenant: 'common',
    clientId: 'c16ec8f9-85c0-4978-b3c8-4972446539a0',
    redirectUri: "https://itscapacitymodaluat.infor.com/",
  },
  fiscalyear:"CY24",
  // First fiscal year in which pay curves exist. For any fiscal year before
  // this, the pay curve grid columns, the pay curve detail fields and the
  // Mapping Configuration admin area are hidden. See services/fiscal-year.helper.ts.
  payCurveMinFiscalYear: "CY27",
  // Feature flags: keep source code identical across branches; behavior is
  // controlled per-environment via angular.json fileReplacements.
  featureFlags: {
    // Account management enabled in UAT for validation.
    accountManagementEnabled: true
  }
};